<template>
    <div class="container" v-if="product">
          <b-row class="h-100 pt-2">
            <b-col cols="12" sm="6" md="4" class="d-flex flex-column align-items-center my-auto">
              <img
                :src="`${product.pathAvatar}?tr=w-150`"
                @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                alt="Image"
              />
            </b-col>
            <b-col cols="12" sm="6" md="8">
              <span class="mt-2" ><b>Nombre: </b> {{ product.name}}</span> <br>
              <span class="mt-2" ><b>Código de barras: </b> {{ product.barCode ? product.barCode : 'Sin registro' }}</span> <br>
              <span class="mt-2 text-justify" ><b>Descripción: </b> {{ product.description ? product.description : 'Sin descripción' }}</span> <br>
              <span class="mt-4" ><b>Precio: </b> {{ currencyFormat(product.cost) }}</span>
            </b-col>
          </b-row>
    </div>
    <div v-else>
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Cargando...</span>
      </div>
    </div>
</template>

<script >
import { currencyFormatPesos } from '@/services/utilities'

export default {
  name: 'product',
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  methods: {
    currencyFormat(money) {
      return currencyFormatPesos(money)
    },
  },
}
</script>

<style>

</style>
